import { game } from 'js/main';

export function cutOutFrame(atlas: string, frameName: string): HTMLCanvasElement {
  const img = game.cache.getImage(atlas);
  const frameData: any = game.cache.getFrameData(atlas);
  const { x, y, width, height } = frameData._frames[frameData._frameNames[frameName]];

  const canvas = document.createElement('canvas');
  canvas.width = width;
  canvas.height = height;
  const ctx = canvas.getContext('2d')!;
  ctx.drawImage(img, x, y, width, height, 0, 0, width, height);
  return canvas;
}
